<vi-page [sidenavs]="true" [footer]="true" [isWhiteBackground]="true">
  <app-downtime-notification head></app-downtime-notification>
  <app-callback-notification head></app-callback-notification>
  <vi-toolbar head color="white">
    <vi-back-button left gtm="onBreadcrumbBack" gtmCategory="booking"></vi-back-button>
    <vi-breadcrumbs
      left
      gtm="onBreadcrumb"
      gtmCategory="booking"
      formerPage="{{ 'GENERAL.PATH.OVERVIEW' | translate }}"
      currentPage="{{ 'GENERAL.PATH.BOOKING_OVERVIEW' | translate }}"
      [navigateTo]="'/installations'"
    ></vi-breadcrumbs>
  </vi-toolbar>

  <vi-content body layoutAlign="justify-start items-start">
    <ng-container
      main
      *ngIf="(installationsStore.loaded$ | async) && (bookingStore.loaded$ | async); else loader"
    >
      <div class="packages-header">
        <h1 data-at-title>
          {{ '+BOOKING.OVERVIEW.TITLE' | translate }}
        </h1>
      </div>
      <!-- Trial package -->
      <ng-container *ngIf="bookingStore.trialSubscriptionsActive$ | async as trialSubscriptions">
        <ng-container *ngIf="trialSubscriptions.length">
          <div class="packages-header">
            <h2 data-at-title>
              {{ '+BOOKING.OVERVIEW.PACKAGES.TEST_VERSION' | translate }}
            </h2>
          </div>

          <div class="subscriptions-container">
            <ng-container *ngFor="let subscription of trialSubscriptions">
              <app-voucher-booking-tile
                [isActiveSubscription]="true"
                [subscription]="subscription"
              ></app-voucher-booking-tile>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>

      <!-- Booked package -->
      <ng-container
        *ngIf="
          bookingStore.activeVoucherSubscription$ | async as subscriptions;
          else noPackageBooked
        "
      >
        <h2 data-at-title>
          {{ '+BOOKING.OVERVIEW.VOUCHER.ACTIVE_SUBSCRIPTIONS' | translate }}
        </h2>

        <ng-container *ngIf="subscriptions.length; else noPackageBooked">
          <div class="subscriptions-container">
            <ng-container *ngFor="let subscription of subscriptions">
              <app-voucher-booking-tile
                [isActiveSubscription]="true"
                [subscription]="subscription"
              ></app-voucher-booking-tile>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>

      <!-- No booked package notification -->
      <ng-template #noPackageBooked>
        <div class="flex flex-row justify-center items-center w-full min-w-full h-full min-h-full">
          {{ '+BOOKING.OVERVIEW.VOUCHER.NO_PACKAGE_BOOKED' | translate }}
        </div>
      </ng-template>

      <!-- Expired packages -->
      <ng-container
        *ngIf="bookingStore.expiredVoucherSubscriptions$ | async as expiredSubscriptions"
      >
        <div class="packages-header">
          <h2 data-at-title>
            {{ '+BOOKING.OVERVIEW.VOUCHER.EXPIRED_SUBSCRIPTIONS' | translate }}
          </h2>
        </div>

        <div
          *ngIf="expiredSubscriptions.length; else noExpiredPackagesMessage"
          class="subscriptions-container"
        >
          <ng-container *ngFor="let expiredSubscription of expiredSubscriptions">
            <!-- Expired pro packages -->
            <app-voucher-booking-tile
              *ngIf="!expiredSubscription.trial"
              [subscription]="expiredSubscription"
            ></app-voucher-booking-tile>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #noExpiredPackagesMessage>
      <div class="flex flex-row justify-center items-center w-full min-w-full h-full min-h-full">
        {{ '+BOOKING.OVERVIEW.PACKAGES.NO_EXPIRED_PACKAGES' | translate }}
      </div>
    </ng-template>

    <ng-template #loader>
      <vi-loader main [isLoading]="true"></vi-loader>
    </ng-template>
  </vi-content>

  <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
  <app-sidenav left-sidenav></app-sidenav>
</vi-page>
